import * as c from './types';
import { AnnotateStopErrorModalData } from './types';

export const showAnnotateStopErrorModal = (
  data: AnnotateStopErrorModalData
) => ({
  type: c.SHOW_ANNOTATE_STOP_ERROR_MODAL,
  payload: data
});

export const hideAnnotateStopErrorModal = () => ({
  type: c.HIDE_ANNOTATE_STOP_ERROR_MODAL
});
